import { render, staticRenderFns } from "./diffinfo.vue?vue&type=template&id=d987370c&scoped=true"
import script from "./diffinfo.vue?vue&type=script&lang=js"
export * from "./diffinfo.vue?vue&type=script&lang=js"
import style0 from "./diffinfo.vue?vue&type=style&index=0&id=d987370c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d987370c",
  null
  
)

export default component.exports